import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import {
    getAllApplicant,
    getSingleApplicant,
    addApplicant,
    deleteApplicant,
    editApplicant
} from "./queries";

const applicantApi = createApi({
    reducerPath: "applicantApi",
    baseQuery: fetchBaseQuery({
        baseUrl: adminBaseUrl,
        prepareHeaders: headerWithAuthToken,
    }),
    endpoints: (builder) => ({
        // get all users
        getAllApplicant: builder.query({
            providesTags: ["all_applicants"],
            query: getAllApplicant,
        }),

        // get single user
        getSingleApplicant: builder.query({
            providesTags: ["applicant"],
            query: getSingleApplicant,
        }),

        addApplicant: builder.mutation({
            invalidatesTags: ["applicant"],
            query: addApplicant,
        }),

        editApplicant: builder.mutation({
            invalidatesTags: ["applicant"],
            query: editApplicant,
        }),

        // delete user account
        deleteApplicant: builder.mutation({
            invalidatesTags: ["applicant"],
            query: deleteApplicant,
        }),
    }),
});

export const {
    useGetAllApplicantQuery,
    useGetSingleApplicantQuery,
    useDeleteApplicantMutation,
    useAddApplicantMutation,
    useEditApplicantMutation,
    reducer: applicantApiReducer,
    reducerPath: applicantApiReducerPath,
    middleware: applicantApiMiddleWare,
} = applicantApi;
